import { defineStore } from 'pinia'
import { ref } from 'vue'

let nextId = 0

export const useToastStore = defineStore('toast', () => {
  const message = ref(null) // { id, text, tone, timeoutId }

  function show(text, opts = {}) {
    if (message.value?.timeoutId) clearTimeout(message.value.timeoutId)
    const id = ++nextId
    const tone = opts.tone || 'info' // 'info' | 'success' | 'error'
    const duration = opts.duration ?? 4500
    const timeoutId = setTimeout(() => {
      if (message.value?.id === id) message.value = null
    }, duration)
    message.value = { id, text, tone, timeoutId }
  }

  function dismiss() {
    if (message.value?.timeoutId) clearTimeout(message.value.timeoutId)
    message.value = null
  }

  return { message, show, dismiss }
})
